import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const ArrowReturn = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="m6.395 6.457-.086.493a.5.5 0 0 1-.413-.51zM12 4.134v.5zm7.93 7.93h.5zM12 20.001v.5zm-8.429-7.94a.5.5 0 0 1 1 0zm6.015-5.554a.5.5 0 1 1-.172.985L9.5 7zM6 3.483a.5.5 0 0 1 1 .035L6.5 3.5zm.395 2.974-.354-.353a8.4 8.4 0 0 1 2.733-1.83l.192.462.191.462A7.4 7.4 0 0 0 6.75 6.81zm2.57-1.72-.19-.463A8.4 8.4 0 0 1 12 3.634v.5l-.001.5a7.4 7.4 0 0 0-2.843.564zM12 4.133v-.5a8.43 8.43 0 0 1 5.96 2.47l-.353.353-.354.354A7.43 7.43 0 0 0 12 4.634zm5.607 2.323.353-.354a8.43 8.43 0 0 1 2.47 5.96h-1a7.43 7.43 0 0 0-2.177-5.252zm2.322 5.606h.5a8.44 8.44 0 0 1-2.468 5.963l-.354-.353-.354-.353a7.44 7.44 0 0 0 2.176-5.257zm-2.322 5.61.354.354A8.44 8.44 0 0 1 12 20.502v-.5l-.002-.5a7.44 7.44 0 0 0 5.254-2.182zM12 20.003v.5a8.44 8.44 0 0 1-5.96-2.477l.353-.353.354-.353A7.44 7.44 0 0 0 12 19.502zm-5.607-2.33-.354.353a8.44 8.44 0 0 1-2.468-5.964h1a7.44 7.44 0 0 0 2.176 5.258zM9.5 7l-.086.493L6.31 6.95l.086-.493.086-.492 3.105.543zm-3.105-.543-.5-.017.106-2.958.5.018.499.018-.105 2.957z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(ArrowReturn) as SvgIcon;
export { ForwardRef as ReactComponent };
